import { useEffect, useState } from 'react';
import LeadStatusService from '../services/LeadStatusService';

export default function usePipelineStages({ clientId, industryId } = {}) {
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(!!(clientId || industryId));

  useEffect(() => {
    if (!clientId && !industryId) {
      setStages([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    const request = clientId
      ? LeadStatusService.getPipelineStagesByClientId(clientId)
      : LeadStatusService.getPipelineStagesByIndustryId(industryId);

    request
      .then((list) => {
        if (!cancelled) setStages(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setStages([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [clientId, industryId]);

  return { stages, loading };
}
